import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import '@/utils/element.js'
import '@/utils/vant.js'
import '@/utils/amap.js'
import 'swiper/swiper-bundle.min.css'
import moment from 'moment'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/vue-awesome-swiper'
import Swiper2, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper2.use([Autoplay, Navigation, Pagination])
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$moment = moment
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
